import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EffectHandlerService } from '@services/effect-handler.service';
import { ApiService } from '@state/api.service';
import {
  listWorkflows,
  listWorkflowsFailure,
  listWorkflowsSuccess,
} from '@state/workflows/workflows.actions';
import { switchMap } from 'rxjs/operators';


@Injectable()
export class WorkflowsEffects {
  actions$ = inject(Actions);
  api = inject(ApiService);
  handler = inject(EffectHandlerService);

  listWorkflows$ = createEffect(() => this.actions$.pipe(
    ofType(listWorkflows),
    switchMap(() => this.api.listWorkflows().pipe(
      this.handler.effectResponse({
        retry: listWorkflows(),
        success: (workflows) => listWorkflowsSuccess({ workflows }),
        failure: listWorkflowsFailure(),
        failureMessage: 'Could not load Workflows',
      })
    ))
  ));
}
